module.exports = __webpack_public_path__ + "fonts/fa-brands-400.3533db5.woff2";